import "primeicons/primeicons.css";
import { childSearchForm } from "../../../shared/formObjects/application/childSearchForm";
import { useApiClient } from "../../../shared/customHooks";
import FormContainer from "../FormContainer";
import { FormikProps } from "formik";

export function ChildSearchComponent({ search }: { search: (firstName: string, lastName: string, dateOfBirth: Date | undefined) => void }) {
  const api = useApiClient("ChildChecker");

  const handleSearch = (values: any) => {
    const firstName = values["firstName"] === null || !values["firstNameCheck"] ? null : values["firstName"];
    const lastName = values["lastName"] === null || !values["lastNameCheck"] ? null : values["lastName"];
    const dateOfBirth = values["dateOfBirth"] === null || !values["dateOfBirthCheck"] ? null : values["dateOfBirth"].toISOString().split("T")[0];

    search(firstName, lastName, dateOfBirth);
  };

  function getInitalValues(initialData: any, formik: FormikProps<any>) {
    formik.setFieldValue("firstNameCheck", true);
    formik.setFieldValue("lastNameCheck", true);
    formik.setFieldValue("dateOfBirthCheck", true);
  }

  return (
    <>
      <FormContainer
        disabled={false}
        apiClient={api}
        formBody={childSearchForm}
        showInternalNotes={false}
        customSubmit={handleSearch}
        hideCancelButton={true}
        submitBtnTitle="Submit"
        hideClearButton={false}
        getInitialValues={getInitalValues}
        displayDirtyFormWarning={false}
      />
    </>
  );
}
